import { register } from '!/repository'
import { model as cartModel } from '$/cart'
import { model as creditCardModel } from '$/credit-card'
import { model as creditCardsModel } from '$/credit-cards'
import { model as paymentInfoModel } from '$/payment-info'
import { model as priceSettingsModel } from '$/price-settings'
import { model as genericModel } from '~/features/payment/generic'
import { $payment } from './l10n'

/* Common stores and events */
register(genericModel.tryClosePaymentPopup, 'tryClosePaymentPopup')
register(genericModel.$isAnyPaymentPopupOpened, '$isAnyPaymentPopupOpened')
register(
  genericModel.$paymentStepRequestIsPending,
  '$paymentStepRequestIsPending'
)
register(genericModel.$paymentError, '$paymentError')
register(paymentInfoModel.$uiPaymentInfo, '$uiPaymentInfo')
register(
  priceSettingsModel.$priceSettingsWithTranslations,
  '$priceSettingsWithTranslations'
)
/* Step 1. Price Settings */
register(priceSettingsModel.$priceSettings, '$priceSettings')
register(priceSettingsModel.$selectedPriceSettings, '$selectedPriceSettings')
register(priceSettingsModel.selectPriceSettings, 'selectPriceSettings')
register(cartModel.postItemToCart, 'postItemToCart')

/* Step 2. Credit Cards */
register(genericModel.$paymentSumTitle, '$paymentSumTitle')
register(genericModel.goBackToPreviousStep, 'goBackToPreviousStep')
register(creditCardsModel.$savedCreditCards, '$savedCreditCards')

/* Step 2.1. New Credit Card */
register(
  genericModel.$paymentFormCreditCardNumberError,
  '$creditCardNumberError'
)
register(
  genericModel.$paymentFormCreditCardExpirationTimeError,
  '$creditCardExpirationTimeError'
)
register(genericModel.$paymentFormCreditCardCvvError, '$creditCardCvvError')
register(creditCardModel.$creditCardType, '$creditCardType')
register(creditCardModel.enterCreditCardNumber, 'enterCreditCardNumber')
register(creditCardModel.enterCreditCardMonth, 'enterCreditCardMonth')
register(creditCardModel.enterCreditCardYear, 'enterCreditCardYear')
register(creditCardModel.enterCreditCardCvv, 'enterCreditCardCvv')

/* Step 3. Success confirmation */
register(genericModel.$invoiceDescription, '$invoiceDescription')
register(genericModel.selectMoviePaymentButton, 'selectMoviePaymentButton')
register(genericModel.selectTvShowPaymentButton, 'selectTvShowPaymentButton')

register($payment, '$payment')
